import React, { useState } from "react";
import SearchIcon from "./svg/SearchIcon";
import CloseIcon from "./svg/CloseIcon";
import InputSearchQrType from "../../../components/input/inputSearchQrType";
import { useDispatch, useSelector } from "react-redux";
import { setFirstPageSearchValue } from "../../../redux/slices/saveValue";

export default function HeaderWebview() {
  const firstPageSearchValue = useSelector(
    (state) => state.saveValue.firstPageSearchValue
  );
  const lang = useSelector((state) => state.changeLang.language.cartType);
  const dispatch = useDispatch();

  const [showState, setShowSearch] = useState(false);

  const handleSearchBtn = () => {
    if (showState) {
      dispatch(setFirstPageSearchValue(""));
    }
    setShowSearch(!showState);
  };

  return (
    <div
      className="position-fixed top-0 start-0 w-100 bg-white py-2 d-flex align-items-center justify-content-between px-3 gap-3"
      style={{ zIndex: 500, height: "56px" }}
    >
      {showState ? (
        <InputSearchQrType
          value={firstPageSearchValue}
          placeholder={lang.search[6]}
          searchBtnText={lang.search[1]}
          className="me-2"
          searchBtnClassName="px-2"
          onChange={(e) => dispatch(setFirstPageSearchValue(e.target.value))}
        />
      ) : (
        <>
          <div style={{ width: "24px" }}></div>
          <div>
            <img
              className="mx-auto cursor-pointer"
              src="/static/pages/logo/logo.svg"
              alt="free QR code generator"
              width="81"
              height="40"
            />
          </div>
        </>
      )}

      <div onClick={handleSearchBtn}>
        {showState ? <CloseIcon /> : <SearchIcon />}
      </div>
    </div>
  );
}
